import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

export const EInvoicingGenericUploadInfoSteps = () => {
  const { t } = useTranslation()

  return (
    <Styled.InstructionsList>
      <li>{t('e_invoice.kyc.step.upload_id.instruction.one')}</li>
      <li>{t('e_invoice.kyc.step.upload_id.instruction.two')}</li>
    </Styled.InstructionsList>
  )
}
